// Set this to false when you want to hide the blog from the site.
export const enableBlog = false;